const swup = new Swup({
  animateHistoryBrowsing: true,
  animationSelector: 'main',
  containers: [
    "main"
  ],
  linkSelector:
    'body:not(.admin-bar) a[href^="' + window.location.origin + '"]:not([data-no-swup]), body:not(.admin-bar) a[href^="/"]:not([data-no-swup])',
  plugins: [
    new SwupA11yPlugin(),
    new SwupMetaTagsPlugin(),
    new SwupBodyClassPlugin(),
    new SwupPreloadPlugin(),
    new SwupScrollPlugin({
      doScrollingRightAway: false,
      animateScroll: false
    }),
  ]
});

document.addEventListener('swup:contentReplaced', (event) => {
  active_nav_item();
  swup_scripts();
  source_reference_prep();
  populate_enquiry();
  filter_control();
  post_filter_control();
  // filter_counter();
  collapsable();
  horizontal_scroll_block();
  live_filter();
  initMap();
  location_detect();
  cta_fixed_show();
  // __dev();
});

document.addEventListener('swup:transitionEnd', (event) => {
  carousel();
});

function active_nav_item(){
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll('nav a');
  for (const link of links) {
      let linkPath = (new URL( link.href )).pathname;
      link.ariaCurrent = linkPath == currentPath ? 'page' : false;
  }
}
active_nav_item();
